import React, { Component } from "react";
import axios from "axios";

import Nav from "../components/Nav";
import Sidebar from "../components/Sidebar";
import { Link } from "react-router-dom";
import firebase from "firebase";
import "../styles/editParkingInfo.css";

//font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import LoadingPage from "../components/LoadingPage";

class editParkingInfo extends Component {
  state = {
    loggedParkingInfo: {},
    occupiedSlots: 0,
    capacity: 0,
    loading: true
  };

  componentDidMount() {
    const db = firebase.firestore();

    db.collection("parking")
      .doc("information")
      .onSnapshot(doc => {
        this.setState({ loggedParkingInfo: doc.data(), loading: false });
      });

    db.collection("parking_status").onSnapshot(querySnapshot => {
      let occupiedSlots = 0;

      this.setState({ capacity: querySnapshot.size, loading: false });

      querySnapshot.docs.map(parking => {
        if (parking.data().status === "Occupied") {
          occupiedSlots++;
        }
        this.setState({ occupiedSlots, loading: false });
        return 0;
      });
    });
  }

  handleChange = e => {
    console.log(e.target.name);
    this.setState({
      loggedParkingInfo: {
        ...this.state.loggedParkingInfo,
        [e.target.name]: e.target.value
      }
    });
  };

  saveButtonHandler = async () => {
    const { loggedParkingInfo } = this.state;
    this.setState({ loading: true });
    try {
      await axios.post("/parking/details/edit", loggedParkingInfo).then(res => {
        alert(res.data.message);
      });
    } catch (err) {
      console.log(err);
    }
    this.setState({ loading: false });
  };
  render() {
    const { loggedParkingInfo } = this.state;
    return (
      <div>
        {this.state.loading ? (
          <LoadingPage />
        ) : (
          <div>
            <Nav />
            <div class="row content-div">
              <div class="col-md-2 d-md-block sidebar">
                <Sidebar />
              </div>

              <div className="col-md-9 ml-sm-auto col-lg-10 p-0">
                <div className="container-fluid">
                  <div className="d-sm-flex align-items-center justify-content-between m-4 shadow-sm p-3 mb-5 bg-white rounded">
                    <h1 className="h3 text-gray-800">
                      Welome back, Development Team!
                    </h1>
                  </div>

                  <div className="card m-5">
                    <div className="card-header">
                      <h6 className="d-inline-block align-middle mb-0 mt-2">
                        <Link type="button" className="btn btn-tool p-0" to="/">
                          <FontAwesomeIcon icon={faArrowLeft} />
                        </Link>{" "}
                        Parking Information
                      </h6>
                      <div className="card-tools float-right d-inline-block align-middle">
                        <Link
                          type="button"
                          className="btn btn-tool"
                          to="/editParkingInfo"
                        >
                          <FontAwesomeIcon icon={faPen} />
                        </Link>
                      </div>
                    </div>
                    <div className="card-body m-5">
                      <div className="">
                        <form>
                          <div className="form-group row justify-content-center">
                            <label className="col-lg-2 col-form-label form-control-label">
                              Capacity
                            </label>
                            <div className="col-lg-2 mr-5">
                              <label className="m-1 text-secondary">
                                {this.state.capacity}
                              </label>
                            </div>
                            <label className="col-lg-2 col-form-label form-control-label ml-5">
                              Occupied
                            </label>
                            <div className="col-lg-2">
                              <label className="m-1 text-secondary">
                                {this.state.occupiedSlots}
                              </label>
                            </div>
                          </div>
                          <div className="form-group row justify-content-center">
                            <label className="col-lg-2 col-form-label form-control-label">
                              Reservation Fee
                            </label>
                            <div className="col-lg-2 mr-5">
                              <input
                                className="form-control"
                                type="text"
                                value={loggedParkingInfo.reservationFee}
                                name="reservationFee"
                                onChange={this.handleChange}
                              />
                            </div>
                            <label className="col-lg-2 col-form-label form-control-label ml-5">
                              Hourly Rate
                            </label>
                            <div className="col-lg-2">
                              <input
                                className="form-control"
                                type="text"
                                value={loggedParkingInfo.hourlyRate}
                                name="hourlyRate"
                                onChange={this.handleChange}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <label className="col-lg-2 col-form-label form-control-label rate-is-fixed-label">
                              Rate is Fixed
                            </label>
                            <div className="col-lg-2">
                              <div class="form-check d-inline-block mr-3 mt-2">
                                <input
                                  onChange={this.handleChange}
                                  class="form-check-input"
                                  type="radio"
                                  name="isFixed"
                                  id="exampleRadios1"
                                  value="true"
                                  checked
                                />
                                <label
                                  class="form-check-label"
                                  for="exampleRadios1"
                                >
                                  YES
                                </label>
                              </div>
                              <div class="form-check d-inline-block">
                                <input
                                  onChange={this.handleChange}
                                  class="form-check-input"
                                  type="radio"
                                  name="isFixed"
                                  id="exampleRadios2"
                                  value="false"
                                />
                                <label
                                  class="form-check-label"
                                  for="exampleRadios2"
                                >
                                  NO
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="ml-5 mt-5 pl-3">
                            <button
                              type="button"
                              class="btn btn-primary ml-5"
                              onClick={this.saveButtonHandler}
                            >
                              Save Changes
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default editParkingInfo;
